import * as tf from '@tensorflow/tfjs'

// Count how many candidate blobs are the chosen trained class. Each blob
// (normalized {x,y,w,h} from the segmenter) is cropped from the live video,
// embedded once with the shared MobileNet, and classified by the trained object
// head. A blob is counted when its top class is `targetClassId` (or any class,
// if none given) with confidence >= minConf. Returns { count, boxes }.
//
// Accuracy depends on the head being trained on TIGHT CROPS of the object (the
// whole-frame training used elsewhere mismatches tight blob crops).
export async function countParts({
    video,
    mobilenet,
    model,
    blobs,
    targetClassId = null,
    minConf = 0.5,
}) {
    if (!video || !mobilenet || !model || !model.head || !blobs || !blobs.length)
        return { count: 0, boxes: [] }

    let probs
    try {
        const feats = tf.tidy(() => {
            const frame = tf.browser.fromPixels(video).toFloat().expandDims()
            const boxes = blobs.map((b) => [b.y, b.x, b.y + b.h, b.x + b.w])
            const boxInd = blobs.map(() => 0)
            const crops = tf.image
                .cropAndResize(frame, boxes, boxInd, [224, 224])
                .div(255)
            return mobilenet.predict(crops).reshape([blobs.length, -1])
        })
        const logits = tf.tidy(() => model.head.predict(feats))
        probs = await logits.array()
        feats.dispose()
        logits.dispose()
    } catch (e) {
        return { count: 0, boxes: [] }
    }

    const classIds = model.classIds || []
    const classNames = model.classNames || []
    const outBoxes = []
    probs.forEach((row, bi) => {
        let top = 0
        for (let i = 1; i < row.length; i++) if (row[i] > row[top]) top = i
        const conf = row[top]
        const classId = classIds[top]
        const matches =
            targetClassId == null || String(classId) === String(targetClassId)
        if (matches && conf >= minConf) {
            outBoxes.push({
                ...blobs[bi],
                label: classNames[top] || 'part',
                conf,
            })
        }
    })
    return { count: outBoxes.length, boxes: outBoxes }
}
